// extracted by mini-css-extract-plugin
module.exports = {"city":"styles_city__2RHL4","rowContainer":"styles_rowContainer__2kbf_","inputsformReservation":"styles_inputsformReservation__Z72dx"};